'use client';
import { Controller, useFormContext } from 'react-hook-form';
import { PromptTextarea } from '../prompt-textarea';

// 定义Props接口，扩展PromptTextarea的属性
interface Props<T> {
  name: string;
  placeholder?: string;
  mode?: 'read' | 'write';
  parser?: (value: T) => string | undefined;
  formatter?: (value: string) => T;
  onFocus?: () => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string;
}

/**
 * RHFPromptTextarea - React Hook Form集成的高级文本输入组件
 *
 * 将PromptTextarea组件与React Hook Form集成，支持表单验证和默认值
 */
export function RHFPromptTextarea<T>({
  name,
  placeholder,
  mode = 'write',
  formatter,
  parser,
  onFocus,
  onBlur,
  error,
  helperText,
  ...other
}: Props<T>) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error: fieldError } }) => (
        <PromptTextarea
          {...other}
          name={name}
          value={parser ? parser(field.value) : field.value}
          onChange={(val) => field.onChange(formatter ? formatter(val) : val)}
          placeholder={placeholder}
          mode={mode}
          onFocus={onFocus}
          onBlur={onBlur}
          error={error || !!fieldError}
          helperText={helperText || fieldError?.message}
        />
      )}
    />
  );
}
